import { useFlow } from "@Libs/Flow/hooks/useFlow";
import { SavePaymentPreferencesFlow } from "../Flows/SavePaymentPreferences/SavePaymentPreferences";

export const useSavePaymentPreferencesFlow = () => {
  return useFlow(SavePaymentPreferencesFlow);
};
